// CSS
import 'reset-css';
import '../css/main.scss';

// Images - PHPテンプレートで使用する画像をViteビルドに含める
import.meta.glob('../images/**/*.(png|jpg|jpeg|svg|gif|webp|webm|mp4)', {
  eager: true,
  import: 'default',
});

// JS Modules
import { initHamburgerMenu } from './hamburger-menu.js';
import { initScrollAnimations } from './scroll-animations.js';
// import './lottie.js';

// dynamic imports
import SwupGaPlugin from '@swup/ga-plugin';
import SwupGtmPlugin from '@swup/gtm-plugin';
import SwupHeadPlugin from '@swup/head-plugin';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Swup from 'swup';

// Register GSAP plugin
gsap.registerPlugin(ScrollTrigger);

const swup = new Swup({
  containers: ['#contents'],
  animationSelector: '[class*="transition-"]',
  plugins: [
    new SwupHeadPlugin({
      persistAssets: true, // CSSやJSアセットを維持
      awaitAssets: true, // アセット読み込み完了を待つ
    }),
    new SwupGtmPlugin(),
    new SwupGaPlugin(),
  ],
});

// ===== ページ内リンクスムーススクロール =====
function initPage() {
  console.log('✨ Page initialized');

  // ハンバーガーメニュー初期化
  initHamburgerMenu();

  // --header-heightのCSS変数を更新
  setHeaderHeightVariable();

  // GSAP ScrollTriggerアニメーション
  initScrollAnimations();

  // ページ内リンクを全て取得
  const smoothScrollLinks = document.querySelectorAll('a[href*="#"]');

  smoothScrollLinks.forEach(link => {
    link.addEventListener('click', e => {
      const href = link.getAttribute('href');

      // 外部リンクや空のハッシュは除外
      if (!href || href === '#' || href.indexOf('#') === -1) {
        return;
      }

      // ハッシュ部分を取得
      const hash = href.substring(href.indexOf('#'));
      const targetElement = document.querySelector(hash);

      if (targetElement) {
        e.preventDefault();

        // スムーススクロール実行 (jQuery animate相当: 820ms)
        const targetPosition = targetElement.offsetTop;
        const startPosition = window.pageYOffset;
        const distance = targetPosition - startPosition;
        const duration = 820;
        let startTime = null;

        const animation = currentTime => {
          if (startTime === null) startTime = currentTime;
          const timeElapsed = currentTime - startTime;
          const run = ease(timeElapsed, startPosition, distance, duration);
          window.scrollTo(0, run);
          if (timeElapsed < duration) requestAnimationFrame(animation);
        };

        // イージング関数 (ease-in-out)
        const ease = (t, b, c, d) => {
          t /= d / 2;
          if (t < 1) return (c / 2) * t * t + b;
          t--;
          return (-c / 2) * (t * (t - 2) - 1) + b;
        };

        requestAnimationFrame(animation);
      }
    });
  });
}

// 初回ロード時
document.addEventListener('DOMContentLoaded', initPage);

// Swupページ遷移後（コンテンツ置き換え完了時）
swup.hooks.on('content:replace', () => {
  console.log('🔄 Swup content replaced');

  // ScrollTriggerインスタンスをクリア（重複防止）
  ScrollTrigger.getAll().forEach(trigger => trigger.kill());

  initPage();
});

// WordPressプラグインのスクリプト再実行用フック
swup.hooks.on('page:view', () => {
  console.log('📄 Swup page:view - Triggering WordPress events');

  // DOMContentLoadedイベントを再トリガー（WordPressプラグイン対応）
  const event = new Event('DOMContentLoaded', {
    bubbles: true,
    cancelable: true,
  });
  document.dispatchEvent(event);

  // jQueryのreadyイベントも再トリガー（jQuery依存のプラグイン対応）
  if (typeof jQuery !== 'undefined') {
    jQuery(document).ready(() => {
      jQuery(document).trigger('ready');
    });
  }
});

// ===== HMR Support (Vite) =====
if (import.meta.hot) {
  import.meta.hot.accept(() => {
    console.log('✅ HMR update received');
  });
}

// --header-heightのCSS変数を:rootに設定
function setHeaderHeightVariable() {
  const header = document.querySelector('.l-header');
  const footer = document.querySelector('.l-footer');

  // 既存のスタイル要素を削除
  const existingStyle = document.getElementById('header-footer-vars');
  if (existingStyle) {
    existingStyle.remove();
  }

  let cssContent = '';

  if (header) {
    const headerHeight = header.offsetHeight;
    cssContent += `--header-height: ${headerHeight}px;`;
  }
  if (footer) {
    const footerHeight = footer.offsetHeight;
    cssContent += `--footer-height: ${footerHeight}px;`;
  }

  if (cssContent) {
    const style = document.createElement('style');
    style.id = 'header-footer-vars';
    style.textContent = `:root { ${cssContent} }`;
    document.head.appendChild(style);
  }
}
window.addEventListener('load', setHeaderHeightVariable);
window.addEventListener('resize', setHeaderHeightVariable);
